var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vedio-desc color-text2"},[_vm._v("\n\t【影片上傳說明】\n\t"),_c('br'),_vm._v("1.請將影片上傳至雲端硬碟，並於此欄位貼上雲端連結（請勿提供 YouTube 或 Canva 連結）。\n\t"),_c('br'),_vm._v("※ 請將連結權限設定為「知道連結的人均可以檢視」，並確認檔案開放下載權限，以利後續下載、整理與使用。\n\t"),_c('br'),_vm._v("2.請直接以「故事名稱」作為影片檔名。例如：故事名稱為「改變世界我可以」，影片檔名即為「改變世界我可以」。\n")])
}]

export { render, staticRenderFns }